/**
* *************************************************************************
*  ADOBE CONFIDENTIAL
*  ___________________
* 
*   Copyright 2017 Adobe
*   All Rights Reserved.
* 
*  NOTICE:  All information contained herein is, and remains
*  the property of Adobe and its suppliers, if any. The intellectual
*  and technical concepts contained herein are proprietary to Adobe
*  and its suppliers and are protected by all applicable intellectual
*  property laws, including trade secret and copyright laws.
*  Dissemination of this information or reproduction of this material
*  is strictly forbidden unless prior written permission is obtained
*  from Adobe.
* **************************************************************************
* 
**/'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _intlFormatCache = require('intl-format-cache');

var _intlFormatCache2 = _interopRequireDefault(_intlFormatCache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * FormattedNumber functional formatter component
 * @param {object} provider the reference to the provider for i18n
 * @param  {number} value Number to be formatted
 * @param  {object} options Options
 * @return {string} formatted number as a string
 * @constructor
 */
function FormattedNumber(provider, _ref) {
  var value = _ref.value,
      options = _objectWithoutProperties(_ref, ['value']);

  try {
    var formatter = (0, _intlFormatCache2.default)(Intl.NumberFormat);
    var locale = provider.state.locale;


    return formatter(locale, options).format(value);
  } catch (error) {
    console.error('Failed to format number.\n' + error + 'For documentaion on options, please refer to:' + 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat');
  }

  return String(value);
}

FormattedNumber.displayName = 'i18nFormattedNumber';

exports.default = FormattedNumber;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@exc-ui/exc-sdk/dist/production/localization/formatters/FormattedNumber.js
// module id = 706
// module chunks = 0